class ClosePopup {
    constructor() {
        this.init();
    }
    CloseEvent = () => {
        let closeBtn = qs('.section-popup-wrapper .close');
        let PopupWrapper = qs('.simply-modal-frame.state-appear');
        closeBtn?.addEventListener('click', () => {
            PopupWrapper.classList.add('hidden');
        })
        window.addEventListener('click', (event) => {
            if (event.target.closest(".simply-modal-overlay.state-show") !== null) {
                PopupWrapper.classList.add('hidden');
            }
        })
    }
    init() {
        this.CloseEvent();
    }
}

new ClosePopup(qs('.section-popup-wrapper'))